export const ROUTES = {
  landing: { path: "/", title: "Scopuz" },
  dashboard: { path: "/dashboard", title: "Dashboard | Scopuz" },
  audits: { path: "/audits", title: "Audits | Scopuz" },
  "ai-visibility-lab": { path: "/ai-visibility-lab", title: "AI Visibility Lab | Scopuz" },
  "ai-tests": { path: "/ai-tests", title: "AI Tests | Scopuz" },
  "ai-testing-lab": { path: "/ai-testing-lab", title: "AI Testing Lab | Scopuz" },
  tools: { path: "/tools", title: "Tools | Scopuz" },
  cli: { path: "/cli", title: "CLI Tool | Scopuz" },
  monitor: { path: "/monitor", title: "Monitoring | Scopuz" },
  changes: { path: "/changes", title: "Monitoring | Scopuz" },
  reports: { path: "/reports", title: "Reports | Scopuz" },
  advanced: { path: "/advanced-audit", title: "Advanced Audit | Scopuz" },
  simulator: { path: "/simulator", title: "Strategy Simulator | Scopuz" },
  compare: { path: "/competitor-intel", title: "Competitor Intel | Scopuz" },
  executive: { path: "/executive-summary", title: "Executive Summary | Scopuz" },
  profile: { path: "/profile", title: "Profile | Scopuz" },
  about: { path: "/about", title: "About | Scopuz" },
  blog: { path: "/blog", title: "Blog | Scopuz" },
  careers: { path: "/careers", title: "Careers | Scopuz" },
  press: { path: "/press", title: "Press | Scopuz" },
  "terms-data-policy": { path: "/terms-and-data-policy", title: "Terms and Data Policy | Scopuz" },
  cookies: { path: "/cookies", title: "Cookie Policy | Scopuz" },
  pricing: { path: "/pricing", title: "Pricing | Scopuz" },
  login: { path: "/login", title: "Sign In | Scopuz" },
  register: { path: "/register", title: "Sign Up | Scopuz" },
};

const TRIAL_ROUTES = {
  audits: "/trial/audits",
  "ai-visibility-lab": "/trial/ai-visibility-lab",
};

export const APP_PAGE_IDS = [
  "dashboard",
  "audits",
  "ai-visibility-lab",
  "ai-tests",
  "ai-testing-lab",
  "cli",
  "monitor",
  "changes",
  "reports",
  "advanced",
  "simulator",
  "compare",
  "executive",
  "profile",
];

export const PRIVATE_PAGE_IDS = [
  "dashboard",
  "cli",
  "monitor",
  "reports",
  "advanced",
  "simulator",
  "compare",
  "executive",
  "profile",
];

const NORMALIZED_PATH_TO_ID = Object.entries(ROUTES).reduce((acc, [id, cfg]) => {
  acc[cfg.path] = id;
  return acc;
}, {});

NORMALIZED_PATH_TO_ID[TRIAL_ROUTES.audits] = "audits";
NORMALIZED_PATH_TO_ID[TRIAL_ROUTES["ai-visibility-lab"]] = "ai-visibility-lab";

export function normalizePath(pathname = "/") {
  if (!pathname || pathname === "/") return "/";
  return pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
}

export function getPageIdFromPath(pathname = "/") {
  const normalized = normalizePath(pathname);
  return NORMALIZED_PATH_TO_ID[normalized] || "landing";
}

export function getPathFromPageId(pageId) {
  return ROUTES[pageId]?.path || ROUTES.landing.path;
}

export function getPathFromPageIdForAuth(pageId, isAuthenticated) {
  if (!isAuthenticated && TRIAL_ROUTES[pageId]) {
    return TRIAL_ROUTES[pageId];
  }

  return getPathFromPageId(pageId);
}

export function getTitleFromPath(pathname = "/") {
  const pageId = getPageIdFromPath(pathname);
  return ROUTES[pageId]?.title || "Scopuz";
}
